import { DocViewerFormat } from 'phoenix/components/documentViewer/documentViewer';
import {
	Acl, 
	DocumentContent,
	DocumentEvents,
	DocumentRevision,
	PermissionType,
	pxItemTypeGuards,
	ShareBaseDocument,
	UploadException,
} from 'phoenix/domain';
import { 
	ActionService,
	EnvironmentService,
	IUriPathService,
	PhoenixToggleService, 
	ProgressService,
	AuthService,
	DisplayMessageService,
	EventSubscriptionService
} from 'phoenix/services';
import * as deleteDialog from 'sharebase/components/deleteDialog/deleteDialog';
import { 
	ShareTab,
	ShareDialogTabs
} from 'sharebase/components/shareDialog/shareDialog';
import { ShareAction } from 'sharebase/components/shareDialog/shareDialog.actions';
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';
import { TaskAction } from 'sharebase/domain';
import { 
	ContextMenuService,
	FavoritesService, 
	IDocumentService, 
	IDesktopService,
	ToastService,
	DesktopNotification
} from 'sharebase/services';
import { AppAction } from 'sharebase-app/components/_app/app.actions';
import { DocumentAction } from 'sharebase-app/components/documentView/documentView.actions';
import { CreateTaskDialog } from 'sharebase-app/components/create-task-dialog/create-task-dialog';
import { RenameDialog } from 'sharebase-app/components/renameDialog/renameDialog';
import { MoveItemDialogController } from 'sharebase-app/components/moveItemDialog/moveItemDialog';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { DownloadDataStore } from 'sharebase-app/dataStores/downloadDataStore';
import { TasksDataStore } from 'sharebase-app/dataStores/tasksDataStore';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { IShareDialogService } from 'sharebase-app/services/shareDialogService';
import { IDocumentNavigationService } from 'sharebase-app/services/documentNavigationService';
import { IDocumentViewService } from 'real-time';
import { IAsyncServiceProvider } from 'util/domain';
import { IFileExtensionFilter } from 'sharebase/filters';
require('./documentView.styles');
const template = require('./documentView.template');

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaDocumentView
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaDocumentView` displays pages of a document
 *
 * @usage
 *
 * <sba-document-view document-id="1234" /> 
 * 
 * @element input
 * @param {integer=} documentId The id of the document to display
 */
export function DocumentViewDirective(
	pxProgressService:ProgressService, 
	pxEventSubscriptionService: IAsyncServiceProvider<EventSubscriptionService>,
	sbaTagDataStore
):ng.IDirective {
	return {
		restrict: 'E',
		controller: DocumentViewController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope:  {
			documentId: '<',
			autoPlayMedia: '<',
			isEmbedded: '<?'
		},
		link: function (scope, element, attrs) {
			var vm = (scope as any).vm;
			scope.$watch('vm.isLoading', function(newVal, oldVal){
				if(newVal){ 
					pxProgressService.target = element[0].querySelector('px-document-viewer');
				}
			});

			scope.$watch('vm.documentId', function(newVal, oldVal){
				if(!newVal){ 
					return;
				}
				
				vm.reloadView();

			});

			scope.$on('$destroy', () => {
				pxProgressService.target = null;
				vm.unsubs.forEach(unsubscribe => unsubscribe());
				vm.sbDesktopService.stopPolling();
				vm.sbaDocumentDataStore.clearStore();
				sbaTagDataStore.clearStore();
				vm.documentViewService.leaveRoom();
				/* note: this does similar work to the unsub function registered above but
				also closes the signalr connection.  long term, this is not necessary and we
				should be able to remove this off() call */
				if (pxEventSubscriptionService.instance)
				{
					pxEventSubscriptionService.instance.off();
				}
			});
		}
	};
}

DocumentViewDirective.$inject = [
	'pxProgressService',
	'pxEventSubscriptionService',
	'sbaTagDataStore'
];

function DocumentViewController(
	$mdDialog:ng.material.IDialogService,
	$mdMedia:ng.material.IMedia,
	$q:ng.IQService,
	$state:ng.ui.IStateService,
	$window:ng.IWindowService,
	pxActionService:ActionService,
	pxAuthService:AuthService,
	pxDisplayMessageService:DisplayMessageService,
	pxEnvironmentService:EnvironmentService,
	pxEventSubscriptionService: IAsyncServiceProvider<EventSubscriptionService>,
	pxPhoenixToggleService:PhoenixToggleService, 
	pxProgressService:ProgressService,
	pxUriPathService: IUriPathService,
	sbFileExtentionFilter:IFileExtensionFilter,
	sbAclDatastore:AclDatastore,
	sbContextMenuService:ContextMenuService,
	sbDesktopService:IDesktopService,
	sbDocumentService:IDocumentService,
	sbFavoritesService:FavoritesService,
	sbHasPreviewsFilter,
	sbrtsDocumentViewService:IDocumentViewService,
	sbToastService:ToastService,
	sbaCreateTaskDialog:CreateTaskDialog,
	sbaDocumentDataStore:DocumentDataStore,
	sbaDocumentNavigationService:IDocumentNavigationService,
	sbaDownloadDataStore:DownloadDataStore,
	sbaMoveItemDialog: MoveItemDialogController,
	sbaRenameDialog:RenameDialog,
	sbaShareDialogService:IShareDialogService,
	sbaTasksDataStore:TasksDataStore,
	sbaToolbarService:ToolbarService,
	gettextCatalog:ng.gettext.gettextCatalog
) {
	var vm = this;
	
	// these are only on the scope so that they are available during $destroy
	vm.unsubs = [];
	vm.sbDesktopService = sbDesktopService;
	vm.media = $mdMedia;
	vm.ViewerFormat = DocViewerFormat;
	vm.pxProgressService = pxProgressService;
	vm.sbaDocumentDataStore = sbaDocumentDataStore;
	vm.document;
	vm.showNextPrevious = false;
	vm.sbaToolbarService = sbaToolbarService;
	vm.docPages = [];
	vm.showContextMenu = (event) => {
		sbContextMenuService.open(vm.document, event);
	};
	vm.documentNavigationService = sbaDocumentNavigationService
	vm.showDocumentNavigation = true; //used to show/hide the next/previous buttons
	vm.environmentService = pxEnvironmentService;
	vm.swipeNext = swipeNext;
	vm.swipePrevious = swipePrevious;
	vm.previewNotification = previewNotification;
	vm.mediaError = mediaError;
	vm.downloadDocument = downloadDocument; 
	vm.documentViewService = sbrtsDocumentViewService;
	vm.isShareByLinkUser = pxAuthService.isShareByLinkUser;
	vm.saveDocument = saveDocument;
	vm.realTimeDocumentUsers = false;
	vm.hasPreview = null;
	vm.reloadView = reloadView;	
	vm.allowDownload = false;
	
	function createTask(item, $event) {
		sbaCreateTaskDialog.open($event, vm.document);
	}

	function loadLatestTask() {
		sbaTasksDataStore.getMyTasksForDocument(vm.documentId)
			.then(documentTasks => {
				let openTasks = documentTasks.filter(docTask => docTask.isOpen)
					.sort((docTask1, docTask2) => {
						if(docTask1.dueDate < docTask2.dueDate) {
							return -1;
						}
						else if(docTask1.dueDate > docTask2.dueDate) {
							return 1;
						}
						return 0;
					});
				vm.assignedTask = openTasks ? openTasks[0] : null;
			});
	}

	function setDocumentData(ignoreCache = false) {
		if (vm.documentId) {
			let p = sbaDocumentDataStore
				.load(+vm.documentId, ignoreCache)
				.then(document => {					
					//set if file has a preview
					vm.hasPreview = sbHasPreviewsFilter(document.Embedded.Document.DocumentName);

					vm.document = document.Embedded.Document;
					vm.noPreviewMessage = gettextCatalog.getString('No preview available for ".{{extension}}" files', {
						extension: sbFileExtentionFilter(vm.document.DocumentName)
					});
					if(!vm.isEmbedded){
						sbaToolbarService.title = document.Embedded.Document.DocumentName;
					}
					vm.docPages = sbaDocumentDataStore.pages.map(function (page) { return page.Url; });
					sbaDocumentNavigationService.setContext(document.Embedded.Document);	
					sbAclDatastore.hasPermission(vm.document, PermissionType.DOWNLOAD)
						.then((result) => vm.allowDownload = result);	

					vm.onLinkViewer = function(_api){
						let viewerApi = _api;
	
						return {
							mode: sbaDocumentDataStore.viewMode,
							docFormat: sbaDocumentDataStore.viewFormat,
							enableTextSelection: function(){
								return sbAclDatastore.load(vm.document)
									.then((acl: Acl) => acl.hasPermission(PermissionType.MODIFY | PermissionType.DOWNLOAD));
							},
							pageCount: sbaDocumentDataStore.pageCount,
							getPageUri: (pageNumber, tabIndex, maxWidth)  => {		
								let section;
								let page = viewerApi.isTabView? tabIndex + 1: pageNumber; 
								
								if(viewerApi.isTabView){
									section = pageNumber - 1;
								}		
						
								return sbaDocumentDataStore.getDocumentUri(page, section, maxWidth);

							},
							getMediaInfo: function() {
								if (viewerApi.isTabView) {
									// get the list of tab names from the server
									return sbaDocumentDataStore.getMediaInfo();
								}
								else {
									return $q.resolve({});
								}
							}
						};
					};

					if(!pxAuthService.isShareByLinkUser) {
						vm.documentViewService.joinRoom(vm.documentId);

						return $q.all([
							sbaDocumentDataStore.getShares(),
							sbaDocumentDataStore.getLinks()
						]);
					}	

				})
				.then(() => {
					pxPhoenixToggleService.with('Platform/Tasks')
						.on(() => {
							loadLatestTask();
						});
					if(!vm.isEmbedded){
						sbaToolbarService.actionTarget = vm.document;
					}
					return sbAclDatastore.load(vm.document);
				}).catch(function(e) {
					var header = gettextCatalog.getString('Content can\'t be viewed');
					var msg = '';
					switch (e.status) {
						case 400:
							msg = gettextCatalog.getString('This document couldn\'t be found.');
							break;
						case 403:
							msg = gettextCatalog.getString('You do not have rights to access this document.');
							break;
						case 404:
							msg = gettextCatalog.getString('This document has been deleted.');
							break;
						default:
							msg = gettextCatalog.getString('An error occurred accessing this document.');
							break;
					}
					pxDisplayMessageService.display(header, msg);
					return $q.reject(e);
				});
			
			pxProgressService.enqueue(p);
			return p;
		}
		else {
			return $q.reject(new Error('No document ID provided.'));
		}
	}

	function swipeNext(){
		if(!pxEnvironmentService.touchEnabled){ return;}
		sbaDocumentNavigationService.next();
	}
	function swipePrevious(){
		if(!pxEnvironmentService.touchEnabled){ return;}
		sbaDocumentNavigationService.previous();
	}

	function deleteDocument(item:ShareBaseDocument | DocumentRevision, event) {
		let purge = false;
		let isRevision = pxItemTypeGuards.isDocumentRevision(item);
		$mdDialog.show({
			parent: angular.element(document.body),
			controller: deleteDialog.DeleteDialogController,
			controllerAs: 'vm',
			template: deleteDialog.template,
			targetEvent: event,
			locals: { item, isRevision },
			clickOutsideToClose: false,
			bindToController: true
		})
		.then((purgeOpt:boolean) => {
			purge = purgeOpt;
			pxProgressService.visible = true;
			let p = $q.resolve();
			if(pxItemTypeGuards.isShareBaseDocument(item) && item.IsFavorite){
				p = sbFavoritesService.removeDocumentFromFavorites(item.DocumentId);
			}				 
				
			return p.then(() => sbaDocumentDataStore.deleteDocument(item, purge));
		})
		.then(() => {
			if (isRevision) {
				sbToastService.showSimple(gettextCatalog.getString('The document revision has been deleted'));
				pxActionService.emit({
					type: DocumentAction.RevisionDeleteSuccess,
					payload: item
				}, event);
			} 
			else {				
				let message = purge ? gettextCatalog.getString('The document has been permanently deleted') :
					gettextCatalog.getString('The document has been deleted');
				sbToastService.showSimple(message);
				pxActionService.emit({
					type: DocumentAction.DeleteSuccess,
					payload: sbaDocumentDataStore.parentFolder
				}, event);
			}
		})
		.catch(function(e) {
			if (e && e.cancelled) {
				// User cancelled dialog, no need to show error message
				return;
			}
			let message = purge ? gettextCatalog.getString('Unable to permanently delete the document') :
				gettextCatalog.getString('Unable to delete the document');
			sbToastService.showSimple(message);
		})
		.finally(() => pxProgressService.visible = false);
	}

	function shareDocument(item, $event) {
		sbaShareDialogService.show($event, vm.document, vm.sbaDocumentDataStore, ShareDialogTabs.UserShare.Create, 3);
	}

	function shareLinkDocument(item,$event) {
		sbaShareDialogService.show($event, vm.document, vm.sbaDocumentDataStore, ShareDialogTabs.LinkShare.Create, 0);
	}

	function viewShares(args: {tab:ShareTab, list:number}, $event: ng.IAngularEvent) {
		let {tab, list} = args;
		sbaShareDialogService.show($event, vm.document, vm.sbaDocumentDataStore,  tab, list);
	}

	function itemRename(item:ShareBaseDocument, $event){
		sbaRenameDialog
		.open($event, item, sbaDocumentDataStore)
		.then(newName => {
			vm.document = sbaDocumentDataStore.document;
			
			if(!vm.isEmbedded){
				vm.sbaToolbarService.actionTarget = vm.document;
				vm.sbaToolbarService.title = vm.document.DocumentName;
			}
		});
	}

	function reloadView(ignoreCache = false){
		// ideally, this would be only a UI router reload or re-fetch of the
		// document data, but that doesn't appear to work
		setDocumentData(ignoreCache);
	}

	// if this document has been edited, refresh it
	function desktopDocUpdated(notifications:DesktopNotification[]){
		const docId = vm.document.DocumentId;
		const newEdit = notifications.some(n => n.Command === "Edit" && n.Embedded.DocumentId === docId);

		if (newEdit) {
			// full reload, instead of loading from cache
			reloadView(true);
		}
	}

	function downloadDocument(item: ShareBaseDocument | DocumentContent) {
		let filename = pxItemTypeGuards.isShareBaseDocument(item) ? item.DocumentName : item.OriginalFileName;
		sbaDownloadDataStore.downloadItems(item as any, filename);
	}

	function mediaError(error: MediaError, isVideo: boolean): void {
		if (error.code === MediaError.MEDIA_ERR_ABORTED) {
			// User aborted loading video. No need to do anything
			return;
		}

		let message = '';
		if (isVideo) {
			message = gettextCatalog.getString('Unable to playback the video');
		} else {
			message = gettextCatalog.getString('Unable to playback the audio');
		}

		sbToastService.showSimple(message);
	}

	// capture current view route, so the user gets navigated to the
	// correct state if the click the action
	var currentContext = $state.current.name;
	function previewNotification(document: ShareBaseDocument): void {
		$state.go(currentContext, { docID: document.DocumentId });
	}

	function moveDocument(target, event) {
		sbaMoveItemDialog.open(event, target, false).then(item => {
			return sbaDocumentDataStore.moveDocument(item.item, item.destination.ref);
		})
		.then(item => {
			sbToastService.showSimple(gettextCatalog.getString('{{documentName}} has been moved', { documentName: item.DocumentName }));
		})
		.catch(res => {
			if (!res) {
				// user cancelled, do nothing
				return;
			}
			let errMessage = gettextCatalog.getString('Unable to move the selected document');
			sbToastService.showSimple(errMessage);
		});
	}

	function copyDocument(target, event) {		

		sbaMoveItemDialog.open(event, target, true).then(item => {
			return sbaDocumentDataStore.copyDocument(item.item, item.destination.ref);
		})
		.then(docs => {
			sbToastService.showSimple(gettextCatalog.getString('{{documentName}} has been copied', { documentName: docs[0].DocumentName }));
		})
		.catch(function(res) {
			if (!res) {
				// user cancelled, do nothing
				return;
			}
			let errMessage = gettextCatalog.getString('Unable to copy the selected document');
			sbToastService.showSimple(errMessage);
		});
	}

	function favoriteDocument() {
		let document:ShareBaseDocument = vm.document;
		return sbFavoritesService
			.setDocumentAsFavorite(document.DocumentId)
			.then(() => {
				document.IsFavorite = true;
				sbToastService.showSimple(gettextCatalog.getString('{{documentName}} has been added to your favorites', { documentName: document.DocumentName }), 1500);
			})
			.catch(() => {
				sbToastService.showSimple(gettextCatalog.getString('Unable to add {{documentName}} your favorites', { documentName: document.DocumentName }), 1500);
			});	
	}

	function unfavoriteDocument() {
		let document:ShareBaseDocument = vm.document;
		return sbFavoritesService
			.removeDocumentFromFavorites(document.DocumentId)
			.then(() => {
				document.IsFavorite = false;
				sbToastService.showSimple(gettextCatalog.getString('{{documentName}} has been removed from your favorites', { documentName: document.DocumentName }), 1500);
			})
			.catch(() => {
				sbToastService.showSimple(gettextCatalog.getString('Unable to remove {{documentName}} from your favorites', { documentName: document.DocumentName }), 1500);
			});	
	}

	function saveDocument(content:string){
		let blob = new Blob([content], {
			type: 'text/plain',
		});

		sbDocumentService.replaceDocument(vm.document, blob)	
			.then(revision => {
				pxActionService.emit({
					type: DocumentAction.Save, 
					payload: revision
				});
			})		
			.catch(e => {
				let msg = gettextCatalog.getString('Error saving document');
				sbToastService.showSimple(msg);
			});
	}

	function replaceErrorCallback(exception:UploadException){
		sbToastService.showSimple(exception.userMessage);
		$window.history.back();
	}

	function replaceSuccessCallback(){
		reloadView(true);
	}

	vm.docReplaceErrorCallback = replaceErrorCallback;
	vm.docReplaceDoneCallback = angular.noop;
	vm.docReplaceCallback = replaceSuccessCallback;
	
	setDocumentData()
		.then(function(){						
			if(!vm.isEmbedded){
				vm.unsubs.push(...pxActionService.subscribe<any>([
					[AppAction.Delete, deleteDocument],
					[AppAction.Rename, itemRename],
					[ShareAction.ViewShares, viewShares],
					[AppAction.CreateDocumentUserShare, shareDocument],
					[AppAction.CreateDocumentLinkShare, shareLinkDocument],
					[AppAction.Download, downloadDocument],
					[AppAction.Copy, copyDocument],
					[AppAction.Move, moveDocument],
					[AppAction.Favorite, favoriteDocument],
					[AppAction.Unfavorite, unfavoriteDocument],
					[DocumentAction.RevisionPromoteSuccess, () => reloadView(true)]
				]));
			}

			pxPhoenixToggleService.isEnabled('Core/RTSActiveUsers')
				.then((enabled) => {
					vm.realTimeDocumentUsers = enabled;
				});

			pxPhoenixToggleService.isEnabled('Platform/Tasks')
				.then((enabled) => {
					if(enabled) {
						vm.unsubs.push(pxActionService.subscribe<any>(AppAction.CreateTask, createTask));
						vm.unsubs.push(pxActionService.subscribe<any>(TaskAction.CompletedTask, loadLatestTask));
					}
				});

			sbDesktopService
				.discover()
				.then(() => {
					sbDesktopService.startPolling();					

					//manage subscriptions
					vm.unsubs.push(sbDesktopService.subscribe(desktopDocUpdated));
				})
				.catch(angular.noop);

			pxEventSubscriptionService.onInit.then(() => {
				vm.unsubs.push(pxEventSubscriptionService.instance.on<{ DocumentId: number }>(
					pxUriPathService.resolvePath('/documents/{id}/subscriptions', { id: vm.documentId }),
					DocumentEvents.Edit,
					m => {
						/// Alerts users viewing a document that a new version of the document has been uploaded.
						let message = gettextCatalog.getString('A new version of this document is available.');
						/// A simple tooltip for the toast message action for refreshing the document view when a new version of the document is available
						let tooltip = gettextCatalog.getString('Refresh');

						sbToastService.showSimpleAction(message, tooltip, () => {
                            reloadView(true);
					}, 10000, 'refresh');
				}));
			});
		});
}

DocumentViewController.$inject = [
	'$mdDialog',
	'$mdMedia',
	'$q',
	'$state',
	'$window',
	'pxActionService',
	'pxAuthService',
	'pxDisplayMessageService',
	'pxEnvironmentService',
	'pxEventSubscriptionService',
	'pxPhoenixToggleService',
	'pxProgressService',
	'pxUriPathService',
	'sbFileExtentionFilter',
	'sbAclDatastore',
	'sbContextMenuService',	            
	'sbDesktopService',
	'sbDocumentService',
	'sbFavoritesService',
	'sbHasPreviewsFilter',
	'sbrtsDocumentViewService',
	'sbToastService',
	'sbaCreateTaskDialog',
	'sbaDocumentDataStore',
	'sbaDocumentNavigationService',
	'sbaDownloadDataStore',
	'sbaMoveItemDialog',
	'sbaRenameDialog',
	'sbaShareDialogService',
	'sbaTasksDataStore',
	'sbaToolbarService',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/documentView/documentView.ts